import React, { Component } from 'react';
import Wrapper from '../assets/wrappers/Footer';
import NICLogo from '../assets/images/NICFULLLOGO.png';
import MOPRLOGO from '../assets/images/PanchayatiRajLogo.png';

type ModalType = 'terms' | 'privacy' | 'contact' | 'manager' | 'purpose' | null;

interface FooterState {
  showModal: ModalType;
}

class Footer extends Component<{}, FooterState> {
  ArchivalAndRetentionPolicy = '/resources/ArchivalAndRetentionPolicy.pdf';

  constructor(props: {}) {
    super(props);
    this.state = {
      showModal: null,
    };
  }

  handleDownload = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  handleShow = (type: ModalType) => {
    this.setState({ showModal: type }, () => {
      setTimeout(() => {
        (window as any).bhashini?.retranslate?.();
      }, 100);
    });
  };

  handleClose = () => {
    this.setState({ showModal: null });
  };

  renderModalContent = () => {
    const { showModal } = this.state;

    if (!showModal) return null;

    return (
      <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">
                {showModal === 'terms' && 'Terms & Conditions'}
                {showModal === 'privacy' && 'Privacy Policy'}
                {showModal === 'contact' && 'Contact Us'}
                {showModal === 'manager' && 'Web Information Manager'}
                {showModal === 'purpose' && 'Purpose Limitation'}
              </h5>

              <button onClick={this.handleClose} type="button" className="btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
                  <path d="M2.5 2.5l11 11m0-11l-11 11" stroke="white" strokeWidth="2" />
                </svg>
              </button>
            </div>

            <div className="modal-body">
              {/* TERMS */}
              {showModal === 'terms' && (
                <>
                  <p>The following terms and conditions will apply if you wish to use the Internet for availing a service. Please go through the conditions carefully and if you accept them, you may register yourself and transact on the site. On using this site for service delivery, you are deemed to have agreed to the terms and conditions set forth below. If You do not agree with all these terms and conditions, you must not transact on this Website.</p>

                  <p>If a user violates the terms and conditions Government (service owner) reserves the right to deactivate all such user registration and cancel any or all services requested without any notice. Garbage / Junk values in profile may lead to Deactivation.</p>

                  <p>Operationalization of this agreement is subject to existing laws and legal processes of the respective Government, and nothing contained in this agreement is in derogation of Government's right to comply with law enforcement requests or requirements relating to your use of this Web Site or information provided to or gathered by this site with respect to such use. You agree that Government may provide details of your use of the Web Site to regulators or police or to any other third party, or in order to resolve disputes or complaints which relate to the Web Site, at Government’s complete discretion.</p>

                  <p>This agreement is made between: respective service owner department of the respective government who has configured the serviceGovernment ('Us') and The User ('You'), the individual, whose details are set out in the Portal User Creation page.</p>

                  <h6>User Creation</h6>
                  <p>You are responsible for maintaining the confidentiality of the password and account, and are fully responsible for all activities that occur under your password or account.</p>

                  <h6>Complaints Procedure</h6>
                  <p>You can reach us on the contact details given in the 'Contacts' option given in the login page.</p>

                  <h6>General Obligations</h6>
                  <p>You shall access web site only for lawful purposes and you shall be responsible for complying with all applicable laws, statutes and regulations in connection with the use of Government web site. This Website is for your personal or commercial use by approved kiosks. You shall not modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer or sell any information, or services obtained from this Website. You shall not create a hypertext link to the Website or "frame" the Website, except with the express advance written permission of the Government.</p>

                  <h6>Information Provided</h6>
                  <p>The information you provide in the Registration page must be complete and accurate. Government 00. reserves the right at all times to disclose any information as deems necessary to satisfy any applicable law, regulation, legal process.</p>

                  <h6>Termination</h6>
                  <p>We may at any time at our sole discretion and without giving any reason or any prior notice terminate or temporarily suspend your access to all or any part of the web site.</p>
                </>
              )}
              {/* PRIVACY */}
              {showModal === 'privacy' && (
                <>
                  <p>SabhaSaar is a digital service of the Ministry of Panchayati Raj, Government of India. We are committed to maintaining the confidentiality and security of the information submitted on this platform.</p>

                  <h6>1. Information Processed</h6>
                  <p>The platform processes only the audio/video recordings uploaded by authorised Panchayat functionaries for the purpose of generating Minutes of Meeting. Basic system-related information may also be collected for ensuring smooth functioning of the service.</p>

                  <h6>2. Use of Information</h6>
                  <p>The data provided on this platform is used solely for enabling the creation of meeting records and for related administrative requirements of the Ministry. The information is not used for any commercial or promotional purpose.</p>

                  <h6>3. Storage and Retention</h6>
                  <p>Uploaded recordings are stored in secure environments and are retained for a limited duration as per the Ministry’s archival and retention practices.</p>

                  <h6>4. Sharing of Information</h6>
                  <p>Information may be shared with authorised systems or government-approved services strictly for processing related to transcription, translation and generation of Minutes. No data is shared for any unauthorised purpose.</p>

                  <h6>5. Security</h6>
                  <p>Appropriate technical and administrative safeguards are in place to protect the data handled by the platform.</p>

                  <h6>6. User Requests</h6>
                  <p>Users may contact the designated official for any requests related to correction, deletion, or other concerns regarding the content they have uploaded.</p>

                  <h6>7. Grievance Redressal</h6>
                  <p>For any queries or grievances related to the use of this platform, users may write to the Web Information Manager / designated grievance officer at:</p>
                  <p>Email: amitagar.309@gov.in</p>

                  <h6>8. Policy Updates</h6>
                  <p>This Privacy Policy may be updated from time to time, and the latest version will be made available on this page.</p>
                </>
              )}
              {/* CONTACT */}
              {showModal === 'contact' && (
                <>
                  <p>Email: egramswaraj[at]gov[dot]in</p>
                  <p>Ministry of Panchayati Raj</p>
                  <p>Government of India</p>
                  <p>Eleventh Floor, J.P. Building,</p>
                  <p>Kasturba Gandhi Marg, Connaught Place,</p>
                  <p>New Delhi-110001</p>
                </>
              )}

              {/* MANAGER */}
              {showModal === 'manager' && (
                <>
                  <p>Shri Amit Agarwal</p>
                  <p>Joint Secretary</p>
                  <p>Email: amitagar[dot]309[at]gov[dot]in</p>
                </>
              )}

              {/* PURPOSE */}
              {showModal === 'purpose' && (
                <>
                  <p>SabhaSaar processes uploaded audio and video recordings solely for generating structured Minutes of Meeting of Gram Sabha and Panchayat proceedings. The data is used only for transcription, translation, and summarization to support Panchayati Raj governance functions. No personal data is extracted for profiling, marketing, or secondary purposes.</p>
                </>
              )}

            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Wrapper>
        <div className="footer-container">
          <div className="left-section">
            <a href="https://panchayat.gov.in/" target="_blank">
              <img src={MOPRLOGO} alt="SabhaSaar Logo" className="footer-logo" />
            </a>
          </div>

          <div className="middle-section">
            <ul className="footer-links">
              <li onClick={() => this.handleShow('terms')}>Terms & Conditions</li>
              <span className="dot">•</span>
              <li onClick={() => this.handleShow('privacy')}>Privacy Policy</li>
              <span className="dot">•</span>
              <li onClick={() => this.handleShow('contact')}>Contact Us</li>
              <span className="dot">•</span>
              <li onClick={() => this.handleShow('manager')}>Web Info Manager</li>
              <span className="dot">•</span>
              <li onClick={() => this.handleShow('purpose')}>Purpose Limitation</li>
              <span className="dot">•</span>
              <li onClick={() => this.handleDownload(this.ArchivalAndRetentionPolicy, 'ArchivalAndRetentionPolicy.pdf')}>
                Data Usage, Archival and Retention Policy
              </li>
            </ul>

            <p className="footer-copy">
              ©2026 SabhaSaar. All rights reserved. Government of India.
            </p>
          </div>

          <div className="right-section">
            <a href="https://www.nic.gov.in/" target="_blank">
              <img src={NICLogo} alt="NIC Logo" className="nic-logo" />
            </a>
          </div>
        </div>

        {this.renderModalContent()}
      </Wrapper>
    );
  }
}

export default Footer;